// THE data-attribute contracts of the grid system — every cross-file DOM
// marker lives here so the contracts are greppable from one place.

/** Opt-in marquee surface: a pointer-events:auto band inside a grid where the
 *  marquee gesture may arm (the grid element itself always qualifies).
 *  Stamped by `WidgetGrid`'s insertion gutters; read by `use-grid-marquee`. */
export const MARQUEE_SURFACE_ATTR = 'data-marquee-surface';

/** Explicit fit-to-content measurement target inside a tile — wins over the
 *  first-scrollable-descendant heuristic. Read by the shell's
 *  `resolveFitTarget`. */
export const GRID_FIT_TARGET_ATTR = 'data-gridfittarget';

/** Marks a hoverable widget card for the container chrome's descendant-hover
 *  suppression (a container's pill/cluster hides while a CHILD card is
 *  hovered). Stamped by `WidgetCard` on non-container cards only — the
 *  container's own card must never match its own suppression rule. */
export const WIDGET_CARD_ATTR = 'data-widgetcard';
